var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEnterprise(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 27,
    viewBox: "0 0 25 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.2483 7.9222C15.1531 7.80315 15.0459 7.69601 14.9388 7.58887C12.6055 5.25553 8.81974 5.25553 6.4745 7.58887C4.12926 9.9222 4.14117 13.7079 6.4745 16.0531C6.58164 16.1603 6.68878 16.2674 6.80783 16.3626",
    stroke: "#207C97",
    strokeWidth: 1.54762,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.17671 15.3748C3.23623 18.4343 2.56957 21.101 3.71242 22.2438C5.46242 23.9938 10.7719 21.5057 15.5814 16.6962C20.3909 11.8866 22.879 6.57711 21.129 4.82711C19.9862 3.68425 17.3195 4.35092 14.2719 6.29139",
    stroke: "#207C97",
    strokeWidth: 1.54762,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.165 22.8039C14.3197 22.1015 16.034 20.6848 17.8078 18.8991C19.5816 17.1134 20.9745 15.4348 21.6888 14.292",
    stroke: "#207C97",
    strokeWidth: 1.54762,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.08258 16.6489C7.64209 16.1609 9.72544 14.768 11.6897 12.8037C13.654 10.8394 15.0112 8.79176 15.5231 7.24414",
    stroke: "#207C97",
    strokeWidth: 1.54762,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.19123 20.78C7.61859 20.78 7.96504 20.4336 7.96504 20.0062C7.96504 19.5789 7.61859 19.2324 7.19123 19.2324C6.76387 19.2324 6.41742 19.5789 6.41742 20.0062C6.41742 20.4336 6.76387 20.78 7.19123 20.78Z",
    fill: "#207C97"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6449 8.51735C19.0723 8.51735 19.4187 8.1709 19.4187 7.74354C19.4187 7.31617 19.0723 6.96973 18.6449 6.96973C18.2175 6.96973 17.8711 7.31617 17.8711 7.74354C17.8711 8.1709 18.2175 8.51735 18.6449 8.51735Z",
    fill: "#207C97"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6319 15.5183C14.0593 15.5183 14.4057 15.1719 14.4057 14.7445C14.4057 14.3172 14.0593 13.9707 13.6319 13.9707C13.2045 13.9707 12.8581 14.3172 12.8581 14.7445C12.8581 15.1719 13.2045 15.5183 13.6319 15.5183Z",
    fill: "#207C97"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnterprise);
export default __webpack_public_path__ + "static/media/enterprise.e780249092acf09585fb4b695d27f206.svg";
export { ForwardRef as ReactComponent };